import { createSlice } from "@reduxjs/toolkit";

// Keeps CMS page content and the related bond-list payload available across content screens.
const cmsDataSlice = createSlice({
  name: "cmsData",
  initialState: {
    cmsData: null,
    cmsBondListData: null,
  },

  reducers: {
    // Store the initial CMS payload and the associated bond list returned by the API.
    addCmsData: (state, action) => {
      state.cmsData = action.payload.cmsData;
      state.cmsBondListData = action.payload.bondsList;
    },
    // Replace the current CMS content tree after edits or refreshes.
    updateCmsData: (state, action) => {
      state.cmsData = action.payload;
    },
    // Append a new FAQ item to the in-memory CMS FAQ collection.
    addfaqData: (state, action) => {
      state.cmsData.faq.push(action.payload);
    },
    // Remove a FAQ item from the in-memory CMS FAQ collection by matching its question text.
    removefaqData: (state, action) => {
      state.cmsData.faq = state.cmsData.faq.filter(
        (item) => item.questtion !== action.payload
      );
    },
  },
});

export const { addCmsData, updateCmsData, addfaqData, removefaqData } = cmsDataSlice.actions;

export default cmsDataSlice.reducer;
